import React from 'react'
import { InlineButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export function LearnMoreButton({ onClick, ...props }) {
  const [t] = useTranslation()
  return (
    <span style={{ marginInlineStart: `4px`, display: 'inline' }}>
      <InlineButton onClick={onClick} {...props}>
        {t('common-ui:learn-more.action', 'Learn More')}
      </InlineButton>
    </span>
  )
}
